export const USER_POLICY_NOTICE_STORAGE_PREFIX = "user-policy-three-users-v2:";

export function clearLocalStorageKeepingPolicyNotices() {
    for (const key of Object.keys(localStorage)) {
        if (!key.startsWith(USER_POLICY_NOTICE_STORAGE_PREFIX)) {
            localStorage.removeItem(key);
        }
    }
}
